<template>
  <div class="creatMessage-box">
    <p class="title">短信配置&nbsp;&nbsp;<strong>[ 短信模板 ]</strong> </p>
    <tips></tips>
    <div class="mb20 order-search-wrap">
      <span>模板id：</span>
      <el-input v-model.trim="mouldSign" @keyup.enter.native="getMessageList()" style="width:200px;" prefix-icon="el-icon-search" placeholder="输入模板id" clearable></el-input>
      <span class="ml20">模板名称：</span>
      <el-input v-model.trim="mouldName" class="mr20" style="width:200px;" @keyup.enter.native="getMessageList()" prefix-icon="el-icon-search" placeholder="输入模板名称" clearable></el-input>
      <span>模板内容：</span>
      <el-input v-model.trim="mouldContent" class="mr20" style="width:200px;" @keyup.enter.native="getMessageList()" prefix-icon="el-icon-search" placeholder="输入模板内容" clearable></el-input>
      <span>审核状态：</span>
      <el-select v-model="isAuditing" @change="getMessageList()">
        <el-option label="全部" :value="-1"></el-option>
        <el-option label="有效" :value="0"></el-option>
        <el-option label="待审核" :value="1"></el-option>
        <el-option label="拒绝" :value="2"></el-option>
      </el-select>
      <el-button type="primary" class="ml20" @click="getMessageList()" >查询</el-button>
      <span class="addBtn">
        <el-button type="primary" style="padding:8px 12px" @click="creatMessage">
          <i class="el-icon-circle-plus"></i>&nbsp;创建模板
        </el-button>
      </span>
    </div>
    <div class="table-wrapper1">
       <el-table :data="messageData" border  v-loading = "loading" highlight-current-row ref="table" :max-height="tableHeight">
        <el-table-column label="模板编号" prop="mouldSign" width="290px"></el-table-column>
        <!-- <el-table-column label="通道编号" prop="platformNum"></el-table-column> -->
         <el-table-column label="模板类型" width="80">
           <template slot-scope="scope">
             <span v-if="scope.row.mouldTypeId == 0">普通短信</span>
             <span v-else>营销短信</span>
           </template>
         </el-table-column>
        <el-table-column label="模板名称" prop="mouldName" width="180px"></el-table-column>
        <el-table-column label="模板内容" prop="mouldContent" width="400px" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.mouldContent}}</span>
          </template>
        </el-table-column>
         <el-table-column label="审核状态" width="90">
           <template slot-scope="scope">
             <span style="color: #67c23a" v-if="scope.row.isAuditing == 0">通过</span>
             <span style="color: orange" v-else-if="scope.row.isAuditing == 1">审核中</span>
             <span style="color: red"  v-else>拒绝</span>
           </template>
         </el-table-column>
         <el-table-column label="审核失败原因" prop="reason" width="280" show-overflow-tooltip>
           <template slot-scope="scope">
             <span>{{scope.row.reason}}</span>
           </template>
         </el-table-column>
         <el-table-column label="是否公用" width="80">
           <template slot-scope="scope">
             <span style="color: #67c23a"  v-if="scope.row.isPublic">是</span>
             <span style="color: red"  v-else>否</span>
           </template>
         </el-table-column>
        <el-table-column label="模板申请原因" prop="mouldReason" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.mouldReason }}</span>
          </template>
        </el-table-column>
         <!--<el-table-column label="是否有参数" width="95">-->
           <!--<template slot-scope="scope">-->
             <!--<span style="color: #67c23a" v-if="scope.row.isParams == 1">是</span>-->
              <!--<span style="color: red" v-else>否</span>-->
           <!--</template>-->
         <!--</el-table-column>-->
         <!--<el-table-column label="是否为自身模板" width="120">-->
           <!--<template slot-scope="scope">-->
             <!--<span style="color: #67c23a" v-if="scope.row.self">是</span>-->
             <!--<span style="color: red"  v-else>否</span>-->
           <!--</template>-->
         <!--</el-table-column>-->

        <!-- <el-table-column label="用户名称"  prop="userName"></el-table-column>
        <el-table-column label="用户电话"  prop="userPhone"></el-table-column> -->
        <el-table-column label="创建时间" prop="createtimeStr" width="170"></el-table-column>
        <el-table-column label="操作" fixed="right"  width="150">
          <template slot-scope="scope">
            <span class="text-blue pointer" @click="sendMsg(scope.row)" v-if="scope.row.isAuditing == 0">发送短信</span>
            <span v-if="scope.row.isAuditing == 0 && scope.row.self"> | </span>
            <span class="text-green pointer" @click="revise(scope.row)" v-if="scope.row.isAuditing != 0 && scope.row.self">修改</span>
            <span v-if="scope.row.isAuditing != 0 && scope.row.self"> | </span>
            <span class="text-red pointer" @click="deleteRow(scope.row,scope.$index)" v-if="scope.row.self">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="txt-r mtop20">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="pageNum"
        :page-sizes="[15, 20, 50, 100]"
        :page-size=pageSize
        layout="total, sizes, prev, pager, next, jumper"
        :total=total>
      </el-pagination>
    </div>
    <creat v-if="show" @closeComponent='close' :data='reviseData'></creat>
    <send v-if="sendShow" @closeSends='closeSend' :sendData="sendData"></send>
  </div>
</template>
<script>
import tips from '../../components/message/tips'
import creat from '../../components/message/creatMessage'
import send from '../../components/message/send'
import api from '../../server/api.js'
export default {
  name: "creatMessage",
  data(){
    return{
      tableHeight: 100,
      loading:false,
      isParams:-1,
      mouldSign:"",
      mouldName:"",
      mouldContent:"",
      isAuditing:-1,
      pageSize: 15,//当前显示条数
      pageNum: 1,//当前页数
      total: 0,//总数
      messageData: [],
      show: false,
      reviseData: null,
      sendShow: false,
      sendData: null,
    };
  },
  created(){
    this.getMessageList();
  },
  methods: {
    getMessageList(){//获取短信模板列表
      let data = {
        "start": this.pageNum,
        "length": this.pageSize,
        // "userName":
        "mouldSign":this.mouldSign,
        "mouldName": this.mouldName,
        "mouldContent":this.mouldContent,
        // isPublic:
        "isAuditing": this.isAuditing==-1 ? null : this.isAuditing,
        "isParams": this.isParams==-1 ? null : this.isParams
      }
      this.loading =true;
      api.getSmsMouldList({data:data}).then(res => {
        this.loading =false;
        this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 100;
        this.messageData = res.data.resultList;
        this.total = res.data.count;
      })
    },
    creatMessage(){//创建短信模板
      this.reviseData = null;
      this.show = true;
    },
    revise(row){//修改短信模板
      this.reviseData = row;
      this.show = true;
    },
    sendMsg(row){
      this.sendShow = true;
      this.sendData = row;
    },
    deleteRow(row,index){//删除模板
      this.$confirm('此操作将永久删除该模板, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let arr = [];
        arr[0] = row.mouldSign
        api.delMessage({data:{"mouldSignList": arr}}).then(res =>{
          if(res.status == 'success'){
            this.$message.success(res.msg);
            this.messageData.splice(index,1)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    close(flag){//关闭创建模板
      this.show = false;
      if(flag){
        this.getMessageList();
      }
    },
    closeSend(){
      this.sendShow = false;
    },
    sizeChange(v){//切换显示条数
      this.pageSize = v;
      this.getMessageList();
    },
    currentChange(v){//切换页数
      this.pageNum = v;
      this.getMessageList();
    },
  },
  components: {
    tips,creat,send
  }
}
</script> 
  




// WEBPACK FOOTER //
// src/view/message/messageList.vue